<div class="calendar-container">
    <div class="custom-header">
        <!-- Navigation Buttons (language-aware) -->
        <button mat-icon-button (click)="previousClicked('month')" class="navigation-button">
            <span class="material-symbols-outlined icon">
                {{ isRtlLanguage() ? 'chevron_right' : 'chevron_left' }}
            </span>
        </button>

        <!-- Month/Year Display -->
        <span class="month-year-display ltr-text" (click)="toggleSelectionPanel()">
            {{ periodLabel }}
        </span>

        <!-- Next Month Button -->
        <button mat-icon-button (click)="nextClicked('month')" class="navigation-button">
            <span class="material-symbols-outlined icon">
                {{ isRtlLanguage() ? 'chevron_left' : 'chevron_right' }}
            </span>
        </button>
    </div>

    <!-- Selection Panel -->
    <div class="selection-panel left-aligned" *ngIf="showSelectionPanel">
        <!-- Panel Header -->
        <div class="panel-header">
            <button class="close-button" (click)="closeSelectionPanel()">
                <span class="material-symbols-outlined close-dialog-btn flex-center"> close </span>
            </button>
        </div>

        <!-- Tab Navigation -->
        <div class="tabs">
            <button class="tab-button" [class.active]="activeTab === 'month'" (click)="setActiveTab('month')">
                {{ 'month' | translate }}
            </button>
            <button class="tab-button" [class.active]="activeTab === 'year'" (click)="setActiveTab('year')">
                {{ 'year' | translate }}
            </button>
        </div>

        <!-- Month Selection Grid -->
        <div class="month-grid" *ngIf="activeTab === 'month'">
            <button
                *ngFor="let month of months"
                class="month-button ltr-text"
                [class.selected]="month.selected"
                [disabled]="month.disabled"
                (click)="selectMonth(month.value)"
            >
                {{ month.displayName }}
            </button>
        </div>

        <!-- Year Selection Grid -->
        <div class="year-grid" *ngIf="activeTab === 'year'">
            <button
                *ngFor="let year of years"
                class="year-button ltr-text"
                [class.selected]="getCurrentYear() === year"
                [disabled]="isYearDisabled(year)"
                (click)="selectYear(year)"
            >
                {{ year }}
            </button>
        </div>
    </div>
</div>